import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GstDetailComponent } from './gst-detail.component';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgbPaginationModule
  ],
  declarations: [GstDetailComponent]
})
export class GstDetailModule {}
